﻿import { WorkItemInfo } from 'runtime/data/workiteminfo';

export class TransferRequested {
    constructor(public workItemInfo: WorkItemInfo, public targetUserId: string, public completionAction: () => void) {}

    static eventName() { return 'WorkTray.TransferRequested'; }

    eventName = TransferRequested.eventName;
}